import { render } from "./EventInfo_client.vue?vue&type=template&id=6d7b1bec"
import script from "./EventInfo_client.vue?vue&type=script&lang=js"
export * from "./EventInfo_client.vue?vue&type=script&lang=js"

import "./EventInfo_client.vue?vue&type=style&index=0&id=6d7b1bec&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__